import spreadsheetModule from "./spreadsheetModule"
import server from "../server"

spreadsheetModule.service("oldSpreadsheetService", ["$translate", "uploadService", "downloadBinary", "spreadsheetExportService", function ($translate, uploadService, downloadBinary, spreadsheetExportService) {
    this.importSpreadsheet = (entityType, spreadsheetData) => {
        return uploadService.post(server.getServiceUrl("search." + entityType) + "spreadsheet", spreadsheetData)
    }

    this.exportTemplate = (entityType) => {
        downloadBinary.get(server.getServiceUrl(
            "search." + entityType) + "spreadsheet", $translate.instant("spreadsheet.template.filename." + entityType) + ".xls")
    }

    this.exportData = spreadsheetExportService.exportSpreadsheet
}])